The role of the owner of the position opening.

This field always returns `Company`.
